/**
 * Shared utility functions used across the application.
 */

/**
 * Format a date string for display (e.g., "1/15/2024")
 */
export function formatDate(dateStr: string): string {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    return d.toLocaleDateString();
}

/**
 * Format a date string for input fields (YYYY-MM-DD)
 */
export function formatDateForInput(dateStr: string): string {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

/**
 * Format a number as currency (e.g., "99.99")
 */
export function formatCurrency(value: number): string {
    return value.toFixed(2);
}

/**
 * Escape HTML to prevent XSS
 */
export function escapeHtml(str: string): string {
    if (!str) return '';
    const div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
}

/**
 * Get the anti-forgery token from the page
 */
export function getAntiForgeryToken(): string {
    const tokenInput = document.querySelector('input[name="__RequestVerificationToken"]') as HTMLInputElement;
    return tokenInput?.value || '';
}

/**
 * Show a notification using Notyf (or alert as fallback)
 */
export function showNotification(message: string, type: 'success' | 'error') {
    const Notyf = (window as any).Notyf;
    if (Notyf) {
        const notyf = new Notyf({
            position: { x: 'right', y: 'top' },
            duration: 3000
        });
        if (type === 'success') {
            notyf.success(message);
        } else {
            notyf.error(message);
        }
    } else {
        alert(message);
    }
}

/**
 * Set the value of a form field by name attribute
 */
export function setFieldValue(name: string, value: string) {
    const el = document.querySelector<HTMLInputElement | HTMLSelectElement>(`[name="${name}"]`);
    if (el) el.value = value;
}

/**
 * Set the value of a hidden input field by name attribute
 */
export function setHiddenValue(name: string, value: string) {
    const input = document.querySelector<HTMLInputElement>(`[name="${name}"]`);
    if (input) input.value = value;
}
